import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import {
    doPasswordUpdate,
    doSignInWithEmailAndPassword
} from '../../../../servises/auth.service';
import { EuiButton, EuiFieldPassword, EuiFormRow } from '@elastic/eui';
import { addToast } from '../../../components/toasts/Toast';

const Styles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  h3 {
    font-size: 16px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.94);
    margin: 0 0 4px 0;
  }
`;

const FormContainerStyled = styled.div`
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 10px 0;
`;

const ChangePassword = props => {
    const { user } = props;

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewtPassword] = useState('');
    const [isSendingSave, setIsSendingSave] = useState(false);

    const handleChange = useCallback(async () => {
        if (isSendingSave) {
            return;
        }

        setIsSendingSave(true);
        try {
            await doSignInWithEmailAndPassword(user.email, currentPassword);
            await doPasswordUpdate(newPassword);
            addToast('Password has been changed', 'suc');
        } catch (error) {
            addToast(error.message || 'Error happened, please retry later', 'error');
        } finally {
            setIsSendingSave(false);
        }
    }, [currentPassword, isSendingSave, newPassword, user.email]);

    return (
        <Styles>
            <h3>Change Password</h3>
            <FormContainerStyled>

                <EuiFormRow label="Current password" fullWidth>
                    <EuiFieldPassword
                        type="dual"
                        value={ currentPassword }
                        onChange={ e => setCurrentPassword(
                            e.target.value) }
                        fullWidth
                    />
                </EuiFormRow>

                <EuiFormRow label="New password" fullWidth>
                    <EuiFieldPassword
                        type="dual"
                        value={ newPassword }
                        onChange={ e => setNewtPassword(
                            e.target.value) }
                        fullWidth
                    />
                </EuiFormRow>

                <EuiButton
                    isDisabled={ !currentPassword || !newPassword }
                    size="s"
                    onClick={ handleChange }
                    fill
                    isLoading={ isSendingSave }
                >Save Password</EuiButton>
            </FormContainerStyled>
        </Styles>
    );
};

export default ChangePassword;
